import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

import {
  parseStreetAddress,
  STREET_NUMBER_MAX_LENGTH,
  STREET_NUMBER_PATTERN,
} from './parse-street-address';

/** @deprecated Use STREET_NUMBER_MAX_LENGTH — kept for existing imports/tests. */
export const STREET_NUMBER_MAX_DIGITS = STREET_NUMBER_MAX_LENGTH;

export { STREET_NUMBER_MAX_LENGTH };

/**
 * Flags `addressLine1` when it is missing a valid leading street number, the
 * number exceeds 10 characters, or the number contains disallowed characters.
 * Allowed: digits, letters, whitespace, `/`, and `-`. See product street
 * address validation rules.
 *
 * Empty / whitespace-only values return null so the existing `isNotEmpty`
 * rule continues to own the required-field message.
 */
export function residenceStreetNumberValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = (control.value ?? '').toString().trim();
    if (!value) {
      return null;
    }

    const { streetNumber } = parseStreetAddress(value);
    if (
      !streetNumber ||
      streetNumber.length > STREET_NUMBER_MAX_LENGTH ||
      !STREET_NUMBER_PATTERN.test(streetNumber)
    ) {
      return { streetNumberError: true };
    }

    return null;
  };
}
